import { httpRequest } from '@v4/http/request';
import { getApiUrl } from '@v4/config';
import { stringifyUrl } from '@v4/common/utils/url';

export const baseUrl = `${getApiUrl()}/dkwp/v3/equipment`;

/**
 * Gets the submodel optionals
 *
 * @param {string} versionId version id
 * @returns {Promise<object>}
 */
export const fetchOptionals = (versionId, query) =>
    httpRequest({ url: stringifyUrl({ url: `${baseUrl}/${versionId}/list`, query }) });
